import talk2Api from 'src/plugins/api/api'
import {
  EXTERNAL_CALENDARS_SETTINGS_ROUTE,
  OAUTH_RETURN_CONNECTION_PARAMETER,
  OAUTH_RETURN_ERROR_PARAMETER
} from 'src/constants/calendar-connections'

export default {
  methods: {
    /**
     * Sends the whole tab to the driver's authorization URL. api-core's callback redirects back to
     * EXTERNAL_CALENDARS_SETTINGS_ROUTE with the outcome in the query, which
     * readCalendarOAuthReturn() picks up.
     *
     * This used to open a popup and watch it. Neither signal a popup offers can be trusted here:
     * both providers serve a Cross-Origin-Opener-Policy document during the flow (app.cal.com's
     * authorize page, calendly.com's login page), which switches the browsing context group and
     * severs the opener. popup.closed then reads true with the window still open on screen, and
     * window.opener is null inside the popup, so the callback's postMessage never leaves it.
     */
    startCalendarOAuth (driver, visibility) {
      return talk2Api.V2.calendarConnections
        .getAuthorizationUrl(driver, visibility, EXTERNAL_CALENDARS_SETTINGS_ROUTE)
        .then(response => {
          window.location.assign(response.data.data.url)
        })
    },

    /**
     * The outcome api-core left on the landing URL, or null when this is an ordinary visit.
     *
     * @returns {{connectionId: string, error: null}|{connectionId: null, error: string}|null}
     */
    readCalendarOAuthReturn () {
      const connectionId = this.$route.query[OAUTH_RETURN_CONNECTION_PARAMETER]
      const error = this.$route.query[OAUTH_RETURN_ERROR_PARAMETER]

      if (!connectionId && !error) {
        return null
      }

      return {
        connectionId: connectionId || null,
        error: error || null
      }
    },

    /** Strips the outcome from the URL so a reload does not replay the message. */
    clearCalendarOAuthReturn () {
      const query = { ...this.$route.query }

      delete query[OAUTH_RETURN_CONNECTION_PARAMETER]
      delete query[OAUTH_RETURN_ERROR_PARAMETER]

      this.$router.replace({ query }).catch(() => {})
    }
  }
}
